import * as api from '../api';

// eslint-disable-next-line
export const getTaskLocations = (args) => {
  return api.callGet('/manager/task-locations', args);
};
